<template>
    <div class="pt-15 animated fadeIn masterGLaccount staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table
                                :settings="tableConfig"
                                :table-items="tableItems"
                                @load-items="getTableData"
                                ref="gofixTable">
                          <template slot="gofix_table:before-control-right" slot-scope="data">
                            <div class="mr-4 d-flex align-items-center">
                              <gofix-form-dropdown
                                  class="highlightDropdown chartOfAccountDropdown"
                                  label=""
                                  :searchable="false"
                                  placeholder="Filter by account"
                                  :options="uobAccount"
                                  v-model="notification_filter" />
                            </div>
                          </template>
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'uob_notification',
        components: {

        },
        data () {
            return {
                tableConfig:{
                    name: 'uob-notification',
                    controls:{
                        create: false,
                        delete: false
                    },
                    filter: {},
                    page: 1,
                    limit: 100,
                    total: 0,
                    fields: [
                        {
                            key: 'id',
                            label: 'id',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:50px",
                            sorting: false,
                            with:50
                        },
                        {
                            key: 'event',
                            label: 'Event',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:100px",
                            sorting: false,
                            with:100
                        },
                        {
                            key: 'account_name',
                            label: 'Account Name',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'account_type',
                            label: 'Account Type',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'account_number',
                            label: 'Account Number',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            sorting: false,
                            with:200
                        },
                        {
                            key: 'account_currency',
                            label: 'Account Currency',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:80px",
                            sorting: false,
                            with:80
                        },
                        {
                            key: 'amount',
                            label: 'Amount',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:150px",
                            sorting: false,
                            with:150
                        },
                        {
                            key: 'transaction_type',
                            label: 'Transaction Type',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'our_reference',
                            label: 'Our Reference',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'your_reference',
                            label: 'Your Reference',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'transaction_text',
                            label: 'Transaction Text',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'transaction_date_time',
                            label: 'Transaction Date Time',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            sorting: false,
                            with:200
                        },
                        {
                            key: 'business_date',
                            label: 'Business Date',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'effective_date',
                            label: 'Effective Date',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'sub_account_indicator',
                            label: 'Sub Account Indicator',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:220px",
                            sorting: false,
                            with:220
                        },
                        {
                            key: 'pay_now_indicator',
                            label: 'Pay Now Indicator',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:220px",
                            sorting: false,
                            with:220
                        },
                        {
                            key: 'instruction_id',
                            label: 'Instruction Id',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'notification_id',
                            label: 'Notification Id',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'remittance_information',
                            label: 'Remittance Information',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                        {
                            key: 'originator_account_name',
                            label: 'Originator Account Name',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:220px",
                            sorting: false,
                            with:220
                        },
                        {
                            key: 'transaction_description',
                            label: 'Transaction Description',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:180px",
                            sorting: false,
                            with:180
                        },
                    ],
                    sortColumn: "id",
                    sortDirection: "desc",
                    isCMS: 0,
                },
                tableItems: [],
                notification_filter:null,
                uobAccount :  process.env.VUE_APP_UOB_API_URL === 'https://api-uat.uob.com.sg' ? ['E M REAL ESTATE PRIVATE LIMITED ','EM SERVICES PTE LTD '] : ['EM SERVICES PTE LTD - A/C 4 ','EM SERVICES PTE LTD ']
            }
        },
        computed: {

        },
        watch: {
          notification_filter : function (val){
            this.$refs.gofixTable.reloadTableItems();
          }
        },
        async created() {

        },
        mounted: async function() {

        },
        updated: async function() {

        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                if(this.notification_filter){
                  tableRequest.filter.account_name = this.notification_filter;
                }
                await this.$store.dispatch("UOBController/getNofications", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$bvToast.toast("Can not load the data", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    })
            },
        }
    }
</script>
